import { Box } from '@mui/material';
import { ContactIcons, Icon, FreshchatLoader } from 'Styles';
import freshchatIcon from 'assets/freshchat.png';
import whatsappIcon from 'assets/whatsapp.png';
import iMessageIcon from 'assets/i-message.png';

const Contacts = ({ productConfig, widget, searchParams }) => {
  const { freshchat, whatsapp, iMessage } = productConfig;
  const userAgent = navigator.userAgent;
  const isIos = /iPhone|iPad|iPod|Mac/i.test(userAgent);

  const handleWhatsapp = () => window.open(`https://api.whatsapp.com/send?phone=${whatsapp}`);

  const handleIMessage = () => {
    const { uid } = searchParams;

    const message = `Hi there support team,\r\rI'm a Lord of the Board player${
      uid && ` and my ID number is ${uid}`
    }.\r\rI need assistance with/I have a feedback on...\r\rLooking forward to your response!`;

    window.open(`https://bcrw.apple.com/urn:biz:${iMessage}?body=${encodeURIComponent(message)}`);
  };

  return (
    <ContactIcons>
      {freshchat && (
        <Box sx={{ position: 'relative' }}>
          {!widget && <FreshchatLoader size={11} thickness={7} />}
          <Icon
            src={freshchatIcon}
            onClick={() => (widget.isOpen() ? widget.close() : widget.open())}
            style={{ pointerEvents: widget ? 'auto' : 'none' }}
          ></Icon>
        </Box>
      )}
      {whatsapp && <Icon src={whatsappIcon} onClick={handleWhatsapp} />}
      {iMessage && isIos && (
        <Icon src={iMessageIcon} style={{ maxWidth: '42px' }} onClick={handleIMessage} />
      )}
    </ContactIcons>
  );
};

export default Contacts;
